<template>
    <b-overlay :show="submitting || updating || generalDeleting" rounded="sm">
    <div class="health-view">
        <div class="bg-white p-3 mt-3 activity-type-create col-12">
            <div class="d-flex title-bar-block mb-2">
                <div class="icon-block me-4">
                    <button id="cancel-label-btn" v-b-tooltip.hover :title="$backLabel()" @click="cancel()">
                        <i class="fa fa-chevron-left text-white" aria-hidden="true"></i>
                    </button>
                </div>
                <div class="text">
                    <span class="me-2">{{ title }}</span>
                </div>
            </div>
                <b-form class="form-sample" @submit.stop.prevent="CreateOrUpdate">
                    <b-row>
                        <b-col cols="12" class="dd">
                            <label class="mb-3" for="user_id"><strong>{{ $translate('user') }}</strong><span
                                    class="red">*</span></label>
                            <b-form-select class="form-control" v-custom-validation="$selectRequired()" value-field="id"
                                text-field="name" id="input-user_id" v-model="model.user_id" required :options="users">
                                <template #first>
                                    <b-form-select-option :value="null">{{ $translate('select_user')
                                    }}</b-form-select-option>
                                </template>
                            </b-form-select>
        
                        </b-col>
                        <b-col cols="12 mt-2">
                            <label class="mb-3"><strong>{{$translate('start_date')}}<span class="red">*</span> </strong></label>
                            <b-form-input type="date" id="input-start-date" v-custom-validation="$textRequired()" v-model="model.start_date"
                                required :placeholder="$translate('enter_date')" ></b-form-input>
                        </b-col>
                        <b-col cols="12 mt-2">
                            <label class="mb-3"><strong>{{$translate('end_date')}}<span class="red">*</span> </strong></label>
                            <b-form-input type="date" id="input-end-date" v-custom-validation="$textRequired()" v-model="model.end_date"
                                required :placeholder="$translate('enter_date')" ></b-form-input>
                        </b-col>
                        <b-col cols="12" class="mt-2">
                            <label class="mb-3">
                                <strong>
                                    {{ $translate('start_time') }}<span class="red">*</span>
                                </strong>
                            </label>
                            <b-form-input
                                type="time"
                                id="input-start_time"
                                v-model="model.start_time"
                                :placeholder="$translate('enter_start_time')"
                                required
                                v-custom-validation="$textRequired()"
                            ></b-form-input>
                        </b-col>
                        
                        <b-col cols="12" class="mt-2">
                            <label class="mb-3">
                                <strong>
                                    {{ $translate('end_time') }}<span class="red">*</span>
                                </strong>
                            </label>
                            <b-form-input
                                type="time"
                                id="input-end_time"
                                v-model="model.end_time"
                                :placeholder="$translate('enter_end_time')"
                                required
                                v-custom-validation="$textRequired()"
                            ></b-form-input>
                        </b-col>
                        <b-col cols="12 mt-2">
                            <label class="mb-3"><strong>{{$translate('shift')}}</strong><span class="red">*</span></label>
                            <b-form-input type="text" id="input-shift" v-custom-validation="$textRequired()" v-model="model.shift"
                                :placeholder="$translate('enter_shift')" ></b-form-input>
                        </b-col>
                        
                       
                      
                        
                      
                     
                        <b-col cols="12" class="mt-3 d-flex gap-2 justify-content-center">
                            <b-button id="submit-btn" variant="info"  type="submit"  v-if="hasPermissionUpdate" class="btn-fw"
                                :disabled="submitting ? true : false">{{ submitLabel }}
                            </b-button>
                            <!-- <b-button variant="info" v-if="hasPermissionUpdate" type="submit" class="btn-fw"
                            :disabled="submitting ? true : false">{{ submitLabel }}
                        </b-button> -->
                            <!-- <b-button v-if="hasPermissionDelete && !isNew" @click="deletehealth()" class="float-right"
                                variant="delete-button" size="fw">
                                {{ $deleteLabel() }}
                            </b-button> -->
                            <b-button id="delete-btn" v-if="!isNew && hasPermissionDelete" @click="delete_user_roster()" class="float-right"
                            variant="delete-button" size="fw">
                            {{ $deleteLabel() }}
                        </b-button>
                            <b-button id="cancel-btn" variant="info" :disabled="submitting" class="btn-fw" @click="cancel()">
                                {{ $cancelLabel() }}
                            </b-button>
                        </b-col>
                    </b-row>
                </b-form>
        </div>
    </div>
    </b-overlay>
</template>
<script>
import popupMixins from '@/mixins/popupMixins'
import permissionsMixins from '@/mixins/permissionsMixins'
import utilityMixins from '@/mixins/utilityMixins'

export default {
    name: 'UserRoster',
    mixins: [popupMixins, permissionsMixins, utilityMixins],
   
    data() {
        return {
            model: {
                id: 0,
              
            },

            updating: false,

            submitting: false,
        }
    },
    computed: {
        componentName() { return this.$translate('user_roster') },
        submitLabel() {
            if (this.submitting && this.model.id) {
                return this.$translate('updating')
            } else if (this.submitting) {
                return this.$translate('creating')
            } else if (this.model.id) {
                return this.$updateLabel()
            } else {
                return this.$createLabel()
            }
        },
        title() {
            return this.isNew ? this.$translate('create_user_roster') : this.$translate('user_roster')
        },
        user_roster() {
            const user_roster = { ...this.$store.state.user_roster.user_roster }
          
          
            return user_roster
        },
      
        user_permissions() {
            return this.$store.getters.user_permissions
        },
        isNew() {
            if (this.model.id == 0 || this.model.id == null) {
                return true
            } else {
                return false
            }
        },
        users(){
            return this.$store.state.user_roster.drivers.map(user => {
            return {
                ...user,
                name: `${user.first_name} ${user.last_name}`
            };
          });
        }
    },
    watch: {
        user_roster: function (val) {
            this.model = val
        },
    },
    methods: {
        cancel() {
            this.$router.push('/ams/user-roster')
        },

        CreateOrUpdate() {
            this.submitting = true
            this.$validator.validate().then(valid => {
                if (valid) {
                    this.$store
                        .dispatch(
                            this.model.id !== 0 ? 'user_roster/update' : 'user_roster/create',
                            this.model
                        )
                        .then(() => {
                            if (this.model.id !== 0) {
                                this.$router.push({ name: 'userRoster' })
                                this.$nextTick(() => {
                                    this.genericToast(
                                        this.componentName,
                                        this.$translate('updated'),
                                        'success',
                                        `${this.componentName} ${this.$translate('update_alert')}`
                                    )
                                })

                            } else {
                                this.$router.push({ name: 'userRoster' })
                                this.$nextTick(() => {
                                    this.genericToast(
                                        this.componentName,
                                        this.$translate('created'),
                                        'success',
                                        `${this.componentName} ${this.$translate('create_alert')}`
                                    )
                                })
                            }
                        })
                        .catch(error => {
                            this.doToast(
                                this.$translate('error'),
                                error.message,
                                'danger'
                            )
                            console.log(error)
                        })
                        .finally(() => {
                            this.submitting = false
                        })
                } else {
                    this.submitting = false
                }
            })
        },

        async delete_user_roster() {
            // Initializing key variables
            const model = { ...this.model,name : this.model.shift }
            const routes = {
                baseRoute: '/ams/user-roster',
                deleteRoute: 'user_roster/delete',
            }
            const notificationFields = {
                type: 'User Roster',
                errorMsg: this.$translate('unable_user_roster_alert'),
            }
            try {
                const result = await this.deleteItem(notificationFields, model, routes);
                if (result){
                    this.submitting = true;
                    this.$emit('success');
                }
            } catch (error) {
                console.error(error);
                this.doToast(this.$translate('error'), this.$translate('unable_alert'), 'danger');
            } finally {
                this.submitting = false;
            }
        },
    },
    mounted() {
        if (this.$route.params.id !== 0) {
            this.$store.dispatch('user_roster/fetchById', this.$route.params.id)
        }
       
    },
}
</script>
<style></style>
